import React, { useState } from "react";
import {
  Alert,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Paper,
  Grid,
  IconButton,
  TextField,
  Typography
} from "@mui/material";
import PhoneField from "../../common/component/PhoneField";
import EmailInput from "../../common/component/EmailInput";
import { isEmailValid } from "../../common/component/util";
import EditIcon from "@mui/icons-material/Edit";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import bkstApi from "../../common/component/api";
import { useNavigate } from "react-router";


export default function EditCustomer(props) {
  const { siteId, customerId, customer } = props;
    const navigate = useNavigate();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const [open, setOpen] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [errors, setErrors] = useState([]);

  const validate = () => {
    let arr = [];
    if (!firstName) {
      arr.push("First Name is missing");
    }
    if (!phone) {
      arr.push("Phone is missing");
    }
    if (email && !isEmailValid(email)) {
      arr.push("Email is incorrect");
    }
    return arr;
  };
  const submit = (e) => {
    e.preventDefault();

    const arr = validate();
    setErrors(arr);
    if (arr.length > 0) {
      return;
    } else {
      setProcessing(true);
      const payload = { firstName, lastName, phone, email, src: customer.src };
      bkstApi.put(`/admin/site/${siteId}/customer/${customerId}`, payload).then((res) => {
        navigate(0);
      });
    }
  };

  if (!open) {
    return (
      <IconButton
        onClick={() => {
          setFirstName(props.customer.firstName);
          setLastName(props.customer.lastName);
          setPhone(props.customer.phone);
          setEmail(props.customer.email);

          setOpen(true);
        }}
      >
        <EditIcon />
      </IconButton>
    );
  } else {
    return (
      <Dialog fullScreen={true} open={open} scroll="paper">
        <form
          onSubmit={submit}
          style={{
            display: "contents"
          }}
        >
          <DialogTitle
            sx={{
              padding: "7px 20px",
              display: "flex",
              gap: "10px",
              justifyContent: "space-between",
              alignItems: "center",
              margin: "0",
              backgroundColor: "#DEDEDE",
              borderBottom: "3px solid #DEDEDE"
            }}
          >
            <IconButton onClick={() => setOpen(false)}>
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h5">Set Customer</Typography>
            <Box>
              <Button type="submit" fullWidth color="primary" variant="contained">
                SUBMIT
              </Button>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ backgroundColor: "#F7F7F7" }}>
            <Container maxWidth="sm">
              {errors && errors.length > 0 && (
                <Box mb={2}>
                  <Alert severity="error">{errors.join(", ")}</Alert>
                </Box>
              )}
              <Box py={6}>
                <Paper elevation={0}>
                  <Box px={2} py={4}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <FormControl variant="outlined" fullWidth>
                          <TextField
                            value={firstName}
                            variant="outlined"
                            fullWidth
                            id="firstName"
                            label="First Name"
                            name="firstName"
                            onChange={(e) => setFirstName(e.target.value)}
                            required
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl variant="outlined" fullWidth>
                          <TextField
                            value={lastName}
                            variant="outlined"
                            fullWidth
                            id="lastName"
                            label="Last Name"
                            name="lastName"
                            onChange={(e) => setLastName(e.target.value)}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl variant="outlined" fullWidth>
                          <PhoneField name="Phone" value={phone} onChange={(phone) => setPhone(phone)} required />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <EmailInput value={email} onChange={(val) => setEmail(val)} />
                      </Grid>
                    </Grid>
                  </Box>
                </Paper>
              </Box>
            </Container>
          </DialogContent>
        </form>
        {processing && (
          <Backdrop open={true} style={{ zIndex: "1000", color: "#fff" }}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </Dialog>
    );
  }
}
